import {
  API_ERROR_CODE,
  API_ERRORS,
  LANG,
  TAG_TYPES,
} from "constants/constants";
import _ from "lodash";

export const isVisibleColumn = (field, visibleColumns) =>
  !_.chain(visibleColumns).find({ value: field }).isNil().value();

export const titles = [
  { id: "turnover_billed", defaultMessage: "CA facturé" },
  { id: "currency", defaultMessage: "Devise" },
  { id: "bill_number", defaultMessage: "N° de facture" },
  { id: "to_bill", defaultMessage: "FAE" },
  { id: "to_bill_comment", defaultMessage: "FAE commentaire" },
];

export const dateColumns = (lang, visibleColumns) => [
  {
    key: "mission_start_date",
    isVisible: isVisibleColumn("mission_start_date", visibleColumns),
    dateFormat: lang === LANG.FR ? "dd/MM/yyyy" : "MM/dd/yyyy",
  },
  {
    key: "mission_end_date",
    isVisible: isVisibleColumn("mission_end_date", visibleColumns),
    dateFormat: lang === LANG.FR ? "dd/MM/yyyy" : "MM/dd/yyyy",
  },
  {
    key: "mission_scheduled_end_date",
    isVisible: isVisibleColumn("mission_scheduled_end_date", visibleColumns),
    dateFormat: lang === LANG.FR ? "dd/MM/yyyy" : "MM/dd/yyyy",
  },
];

export const managerAndFeeColumns = [
  { key: "manager_name", width: "150px" },
  { key: "mission_current_fee" },
  { key: "worker_name", width: "150px", isLink: true },
];

export const advAndAnalyticalColumns = [
  { key: "mission_adv_name", width: "150px" },
  { key: "mission_analytical_code" },
];

export const missionSignedAndChargedByColumns = [
  {
    key: "mission_signed_by_name",
    idKey: "mission_signed_by_id",
    readOnly: true,
    type: TAG_TYPES.BRANCHES,
  },
  {
    key: "mission_charged_by_name",
    idKey: "mission_charged_by_id",
    type: TAG_TYPES.BRANCHES,
  },
];

export const apiErrorFinder = (errorCode) =>
  API_ERRORS?.find((e) => e.code === errorCode)?.errorMessage;

export const errorCellNameFormatted = {
  mission_end_date: {
    name: "end_date",
    errorMessage: apiErrorFinder(API_ERROR_CODE.END_DATE_BEFORE_BILL),
    code: "end_date_before_bill",
  },
  mission_start_date: {
    name: "start_date",
    errorMessage: apiErrorFinder(API_ERROR_CODE.START_DATE_AFTER_BILL),
    code: "start_date_after_bill",
  },
  name: {
    name: "name",
    errorMessage: apiErrorFinder(API_ERROR_CODE.INVALID_MISSION_NAME),
    code: "invalid_mission_name",
  },
};

export const handleErrorDisplay = (missionId, errorCellName, errorMissions) => {
  const missionError = errorMissions?.find((e) => e?.missionId === missionId);
  const hasError = missionError?.errors?.some(
    (err) => err?.code === errorCellNameFormatted?.[errorCellName]?.code
  );
  const cellClassName = hasError ? "spreadsheetErrorCell" : "";
  return cellClassName;
};
